const privacyTimer = setInterval(() => {
    if(window.tC && window.tC.domReady && document.getElementById("optout_link") && document.getElementById("optout_link").hasAttribute("href")) {
        document.getElementById("optout_link").removeAttribute("href");
        document.getElementById("optout_link").setAttribute("style", "cursor:pointer");
        clearInterval(privacyTimer);
    }
}, 1000);